module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external "mobx"
// module id = 11
// module chunks = 0 1